
var { isMobile } = require("./lib/breakpoints");
var { makeTranslate, classify, COLORS } = require("./lib/helpers");

var d3 = {
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-axis/dist/d3-axis.min")
};

// Render a bar chart.
module.exports = function (config) {
  // Setup
  var labelColumn = "item";
  var valueColumn = "amt";
  

  var blockHeight = 20;
  if (isMobile.matches) {
    blockHeight = 15;
  }

  const dataLength = config.originalData.length

  const MAX_ITEMS_PER_BIN = 20;
  const BIN_OFFSET = 23;  

  var blockGap = 1.5;
  

  var margins = {
    top: 20,
    right: 20 + BIN_OFFSET,  
    bottom: 20,
    left: 20,  
  };

  // Determine largest bin
  var largestBin = Math.max.apply(
    null,
    config.data.map(b => b.length)
  );

  // Calculate actual chart dimensions
  var chartWidth = config.width - margins.left - margins.right;
  var chartHeight = (blockHeight + blockGap) * MAX_ITEMS_PER_BIN;

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");

  // Create the root SVG element.
  var chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");

  var chartElement = chartWrapper
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom + 25)
    .append("g")
    .attr("transform", makeTranslate(margins.left, margins.top));

  // Create D3 scale objects.
  var xScale = d3
  .scaleBand()
  .domain(config.bins.slice(0, -1).filter(b => {
    return b === 0 || (b !== -0.0001 && b !== 0.0001);
  }))
  .range([0, chartWidth])
  .padding(0.1);

    var yScale = d3
    .scaleLinear()
    .domain([0, MAX_ITEMS_PER_BIN])  
    .range([chartHeight, 0]);

 // Filter tick values and remove 0.0002
const tickValues = config.bins.filter(b => {
  // Keep all negative values and zero, but skip special zero-adjacent values
  if (b <= 0) {
    return b !== -0.0001;
  }
  // For positive values, skip 0.0001 and 0.0002
  return b !== 0.0001 && b !== 0.0002;
}).slice(0, -1);

// Create D3 axes with modified tick formatting
var xAxis = d3
  .axisBottom()
  .scale(xScale)
  .tickValues(tickValues)
  .tickFormat((d) => {
    // Special case for zero bin
    if (d === 0) return '0%';
    
    // Mobile-specific formatting
    if (isMobile.matches) {
      // For negative values on mobile
      if (d < 0) {
        // Only show -80% and -40%
        if (d === -80 || d === -40) {
          return d + "%";
        }
        return "";
      }
      
      // For positive values on mobile
      if (d > 0) {
        const nextBin = config.bins[config.bins.indexOf(d) + 1];
        // Only show +40% and +80%
        if (nextBin === 40 || nextBin === 80) {
          return "+" + nextBin + "%";
        }
        return "";
      }
    } else {
      // Desktop formatting remains unchanged
      // For positive values
      if (d > 0) {
        const nextBin = config.bins[config.bins.indexOf(d) + 1];
        if (nextBin % 20 === 0) {
          return "+" + nextBin + "%";
        }
        return "";
      }
      
      // For negative values
      if (d % 20 === 0) {
        return d + "%";
      }
    }
    return "";
});

    var yAxis = d3
    .axisLeft()
    .scale(yScale)
    .ticks(MAX_ITEMS_PER_BIN/2)  // Half as many ticks
    .tickFormat(d => d); 

  // Render axes to chart.
  var xAxisElement = chartElement
  .append("g")
  .attr("class", "x axis")
  .attr("transform", `translate(${0}, ${chartHeight})`)  
  .call(xAxis);

  d3.select(".x.axis .domain").remove();


  // Create xAxis label
  xAxisElement
    .append("text")
    .attr("class", "label-xaxis")
    .attr("transform", `translate(${0}, ${chartHeight})`)  
    .attr("transform", makeTranslate(chartWidth / 2 + BIN_OFFSET, margins.bottom + 20))
    .html(dataLength > 60 ? LABELS.title_x_2023 : LABELS.title_x_2019);


    // After creating xAxisElement, adjust tick positions
    xAxisElement.selectAll(".tick").each(function(d) {
      if (d !== 0) {
        const tickEl = d3.select(this);
        const transform = tickEl.attr("transform");
        const currentX = parseFloat(transform.match(/translate\(([^,]+)/)[1]);
        const bandwidth = xScale.bandwidth();
        
        let newX;
        if (d < 0 && isMobile.matches) {
          // For mobile negative values, shift right by one position
          newX = currentX + bandwidth + bandwidth/2 - 12;
        } else if (d < 0) {
          // Desktop negative values
          newX = currentX + bandwidth/2 - 12;
        } else {
          // Positive values
          newX = currentX + bandwidth/2 + BIN_OFFSET;
        }
        
        tickEl.attr("transform", `translate(${newX},0)`);
      } else {
        // Zero tick positioning remains the same
        const tickEl = d3.select(this);
        const transform = tickEl.attr("transform");
        const currentX = parseFloat(transform.match(/translate\(([^,]+)/)[1]);
        const newX = currentX + BIN_OFFSET;
        tickEl.attr("transform", `translate(${newX},0)`);
      }
    });

  // Render grid to chart.
  var yAxisGrid = function () {
    return yAxis;
  };

  var yAxisElement = chartElement
    .append("g")
    .attr("class", "y grid")
    .call(
      yAxisGrid()
        .tickSize(-chartWidth, 0)
      // .tickFormat("")
    );

  yAxisElement.select(".tick:last-of-type text")
    .clone()
    .attr("x", "2.5em")
    // .attr("class", "shadow")
    // .text(LABELS.title_y)
    .clone()
    .attr("class", "label")
    .text(LABELS.title_y);

  var bandwidth = xScale.bandwidth();
  var shift = -(bandwidth / 2) - (bandwidth * 0.1) / 2;
  var tickShift = function (d, i) {
    var existing = this.getAttribute("transform").match(
      /translate\(([^)]+)\)/
    )[1];
    existing = existing.split(",").map(Number);
    existing[0] += shift;
    existing[1] += 3;
    return makeTranslate(...existing);
  };


  /*================================*/
// Add background shading for zero line
  /*================================*/
  
    const zeroX = xScale(0);

chartElement
  .append("rect")
  .attr("class", "zero-line-bg")
  .attr("x", xScale(0) + BIN_OFFSET)  
  .attr("y", 0)
  .attr("width", bandwidth) 
  .attr("height", chartHeight)
  .attr("fill", "#e6e6e6");

// Add "Decreased" and "Increased" labels
chartElement
  .append("text")
  .attr("class", "direction-label")
  .attr("x", xScale(0) + BIN_OFFSET - 10)
  .attr("y", 25)
  .attr("text-anchor", "end")
  .text("← Decreased ");

chartElement
  .append("text")
  .attr("class", "direction-label")
  .attr("x", xScale(.0002) + BIN_OFFSET + 5)
  .attr("y", 25)
  .attr("text-anchor", "start")
  .text("Increased →");


  /*================================*/
  // Render the bins to the d3 chart, and add in the tooltip
  /*================================*/

// Modify the bins section to limit display
var bins = chartElement
  .selectAll(".bin")
  .data(config.data)
  .enter()
  .append("g")
  .attr("class", (d, i) => {
    return "bin bin-" + i;
  })
  .attr("transform", (d, i) => `translate(${xScale(config.bins[i]) + BIN_OFFSET}, 0)`);

// Update bins to limit display and add remaining count
bins.each(function(d, binIndex) {
  const g = d3.select(this);
  

  const binItems = d.map(itemName => {
    const originalItem = config.originalData.find(original => original.item === itemName);
    return {
      name: itemName,
      originalData: originalItem || {},
      amt: originalItem?.amt || 0
    };
  });
  
  // Sort items by amount (lowest to highest)
  binItems.sort((a, b) => a.amt - b.amt);
  
  const displayCount = Math.min(MAX_ITEMS_PER_BIN, binItems.length);
  const remainingCount = binItems.length - displayCount;
  
  // Display first 10 items (after sorting)
  g.selectAll("rect")
    .data(binItems.slice(0, displayCount))
    .enter()
    .append("rect")
    .attr("width", xScale.bandwidth())
    .attr("x", 0)
    .attr("y", (d, i) => chartHeight - (blockHeight + blockGap) * (i + 1))
    .attr("height", blockHeight)
    .attr("fill", d => config.colors[binIndex])
    .attr("class", d => classify(d.name))
    .attr("data-original", d => JSON.stringify(d.originalData)); // Store full original data

  // Add remaining count text if there are more items
  if (remainingCount > 0) {
    g.append("text")
      .attr("class", "remaining-count")
      .attr("x", xScale.bandwidth() / 2)
      .attr("y", chartHeight - (blockHeight + blockGap) * (displayCount + 1))
      .attr("text-anchor", "middle")
      .attr("dy", "1em")
      .text(`+${remainingCount} more`);
  }
});

  /*================================*/
  //This is the tooltip implementation  that shows the information on hover
  /*================================*/
// Tooltip implementation
const tooltip = document.createElement('div');
tooltip.className = 'tooltip';
tooltip.style.position = 'absolute';
tooltip.style.visibility = 'hidden';
tooltip.style.background = 'white';
tooltip.style.padding = '5px';
tooltip.style.border = '1px solid #ddd';
document.body.appendChild(tooltip);

// Add event listeners to all rectangles
document.querySelectorAll('rect').forEach(rect => {
  rect.addEventListener('mouseenter', function(event) {
    
    tooltip.innerHTML = `
      <div>
        ${originalData.Brand ? `<span style="font-weight: bold">${originalData.Brand}</span> ` : ''}
        ${originalData.item_full || originalData.item || 'Item'} 
        changed ${(originalData.amt || 0).toFixed(1)}%
      </div>
    `;
    tooltip.style.visibility = 'visible';
    
    const left = event.clientX + window.scrollX + 10;
    const top = event.clientY + window.scrollY + 10;
    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${top}px`;
  });

  rect.addEventListener('mousemove', function(event) {
    const left = event.clientX + window.scrollX + 10;
    const top = event.clientY + window.scrollY + 10;
    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${top}px`;
  });

  rect.addEventListener('mouseleave', function() {
    tooltip.style.visibility = 'hidden';
  });
});

/*================================*/
  // Render the annotations for the hex bins
  /*================================*/
  // Define Y positions for items
const positions = {
  banana: chartHeight - (blockHeight + blockGap) * 3,  // -35.06%
  salmon: chartHeight - (blockHeight + blockGap) * 4,  // -25.04%
  pork: chartHeight - (blockHeight + blockGap) * 2,    // -23.41%
  eggs: chartHeight - (blockHeight + blockGap) * 5,    // 47.29%
  beef: chartHeight - (blockHeight + blockGap) * 3,    // 7.24%
  tp: chartHeight - (blockHeight + blockGap) * 4       // 36.54%
};

const annotations = chartElement.append("g")
  .attr("class", "annotations");

// Add dot marker definition
annotations.append("defs")
  .append("marker")
  .attr("id", "annotation-dot")
  .attr("viewBox", "0 0 10 10")
  .attr("refX", 5)
  .attr("refY", 5)
  .attr("markerWidth", 5)
  .attr("markerHeight", 5)
  .append("circle")
  .attr("cx", 5)
  .attr("cy", 5)
  .attr("r", 3)
  .attr("fill", "#666");

// Function to add annotation to a specific bin and position
function addAnnotation(binValue, itemPosition, labelText, options = {}) {
  const {
    side = 'left',      // 'left' or 'right'
    offset = 10,        // Text offset from the line
    lineLength = 50,    // Length of the annotation line
    direction = 'horizontal', // 'horizontal', 'vertical', or 'diagonal'
    verticalOffset = 20 // For vertical/diagonal lines, how far up/down to go
  } = options;
  
  // Calculate x position based on bin value
  const x = xScale(binValue) + xScale.bandwidth() / 2 + BIN_OFFSET;
  
  // Calculate y position based on item position in bin
  // itemPosition counts from bottom, starting at 1
  const y = chartHeight - (blockHeight + blockGap) * itemPosition;
  
  // Calculate end points based on direction
  let x2, y2, textX, textY;
  
  switch(direction) {
    case 'vertical':
      x2 = x;
      y2 = y + (side === 'top' ? -verticalOffset : verticalOffset);
      textX = x;
      textY = y2 + (side === 'top' ? -offset : offset);
      break;
      
    case 'diagonal':
      x2 = x + (side === 'left' ? -lineLength : lineLength);
      y2 = y + (side === 'top' ? -verticalOffset : verticalOffset);
      textX = x2 + (side === 'left' ? -offset : offset);
      textY = y2;
      break;

      case 'straight':
        x2 = x;
        y2 = y + (side === 'top' ? -lineLength : lineLength);  // Use lineLength instead
        textX = x;
        textY = y2 + (side === 'top' ? -offset : offset);
        break;
      
    case 'horizontal':
    default:
      x2 = x + (side === 'left' ? -lineLength : lineLength);
      y2 = y + blockHeight / 2;
      textX = x2 + (side === 'left' ? -offset : offset);
      textY = y2;

      
  }
  
  // For vertical lines, we might want to add a small horizontal segment
  if (direction === 'vertical') {
    // Add main vertical line
    annotations.append("line")
      .attr("class", "annotation-line")
      .style("stroke", "#666")
      .style("stroke-width", 1)
      .attr("x1", x)
      .attr("y1", y + blockHeight / 2)
      .attr("x2", x2)
      .attr("y2", y2);
      
    // Add small horizontal segment
    const horizontalLength = 20;
    annotations.append("line")
      .attr("class", "annotation-line")
      .style("stroke", "#666")
      .style("stroke-width", 1)
      .attr("x1", x2)
      .attr("y1", y2)
      .attr("x2", x2 + (side === 'left' ? -horizontalLength : horizontalLength))
      .attr("y2", y2)
      .attr("marker-end", "url(#annotation-dot)");
} else if (direction === 'straight') {
    // Just a straight vertical line with dot at end
    annotations.append("line")
      .attr("class", "annotation-line")
      .style("stroke", "#666")
      .style("stroke-width", 1)
      .attr("x1", x)
      .attr("y1", y + blockHeight / 2)
      .attr("x2", x2)
      .attr("y2", y2)
      .attr("marker-end", "url(#annotation-dot)");
} else if (direction === 'diagonal') {
    annotations.append("line")
      .attr("class", "annotation-line")
      .style("stroke", "#666")
      .style("stroke-width", 1)
      .attr("x1", x)
      .attr("y1", y + blockHeight / 2)
      .attr("x2", x2)
      .attr("y2", y2)
      .attr("marker-end", "url(#annotation-dot)");
} else {
    // Horizontal line
    annotations.append("line")
      .attr("class", "annotation-line")
      .style("stroke", "#666")
      .style("stroke-width", 1)
      .attr("x1", x)
      .attr("y1", y + blockHeight / 2)
      .attr("x2", x2)
      .attr("y2", y2)
      .attr("marker-end", "url(#annotation-dot)");
}
    
// Add the label text (only once, at the end)
annotations.append("text")
  .attr("class", "annotation-label")
  .attr("x", textX)
  .attr("y", textY)
  .attr("dy", "0.35em")
  .attr("text-anchor", direction === 'straight' ? "middle" :
                      direction === 'vertical' ? "middle" : 
                      (side === 'left' ? "end" : "start"))
  .text(labelText);
}

if(dataLength > 60) {
  addAnnotation(-40, 1, "Bananas (-35.1%)", {
    side: 'left',
    direction: 'horizontal',
    verticalOffset: -20,  
    lineLength: 35,       
    offset: 5          
  });
  
  // Vertical annotation
  addAnnotation(-30, 4, "Salmon (-25.0%)", {
    side: 'left',
    direction: 'diagonal',
    verticalOffset: -30,  
    lineLength: 35,   
    offset: 10           
  });
  
  
  addAnnotation(40, 2, "Eggs (+46.4%)", {
    side: 'right',
    direction: 'horizontal',
    verticalOffset: -30,  // Negative makes it go up
    lineLength: 30,
    offset: 5
  });
  
  // Ground Beef - Horizontal line
  addAnnotation(0.0002, 10, "Ground beef, 1 lb. (+7.2%)", {
   side: 'right',
    direction: 'horizontal',
    verticalOffset: -30,  
    lineLength: 35,   
    offset: 10      
  });
  
} else {
  
  // Vertical annotation
  addAnnotation(-30, 1, "Grapes (-20.2%)", {
    side: 'left',
    direction: 'diagonal',
    verticalOffset: -30,  
    lineLength: 30,   
    offset: 10          
  });
  
  
  addAnnotation(80, 2, "Eggs (+83.1%)", {
    side: 'top',
    direction: 'straight',
    verticalOffset: 20,  
    lineLength: 40,   
    offset: 20     
  });
  
  // Ground Beef - Horizontal line
  addAnnotation(30, 6, "Ground beef, 1 lb. (+33.9%)", {
    side: 'right',
    direction: 'diagonal',
    verticalOffset: -20,  
    lineLength: 10,   
    offset: 5       
  });
  
  // Toilet Paper - Vertical line going up
  addAnnotation(10, 5, "Toilet paper (+14.2%)", {
    side: 'left',
    direction: 'diagonal',
    verticalOffset: -30,  
    lineLength: 50,   
    offset: 10      
  });
  
}
};